/**
 * Article-open CI smoke only.
 * DEV and production hosts are not loopback, and local preview does not set
 * the flag, so Auth and Firestore stay on the real project.
 * Ports match firebase.json emulators.auth / emulators.firestore.
 */
const CI_EMULATOR_FLAG = 'seowritee_ci_emulators';

export function ciEmulatorPorts(): {authUrl: string; firestoreHost: string; firestorePort: number} | null {
    if (typeof window === 'undefined') {
        return null;
    }
    const host = window.location.hostname;
    if (host !== '127.0.0.1' && host !== 'localhost' && host !== '[::1]') {
        return null;
    }
    try {
        if (sessionStorage.getItem(CI_EMULATOR_FLAG) !== '1') {
            return null;
        }
    } catch {
        return null;
    }
    const connectHost = host === '[::1]' ? '127.0.0.1' : host;
    return {
        authUrl: `http://${connectHost}:9099`,
        firestoreHost: connectHost,
        firestorePort: 5002,
    };
}
